import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <Section data-test="notes-section">
      <SectionHeader>
        <SectionTitle>Notes</SectionTitle>
      </SectionHeader>
      <p>Follow up with the customer about the pricing question.</p>
    </Section>
  );
}

export function PlaygroundSectionNotes() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
